<template>
  <v-stepper
    class='guests-stepper'
    alt-labels
    :value='currentStep'
  >
    <v-stepper-header>
      <v-stepper-step
        v-for='(guest, index) in guests'
        :key='`${guest.id}-${index}`'
        :step='index'
        :complete='guestCompletions[guest.id]'
      ></v-stepper-step>
    </v-stepper-header>
  </v-stepper>
</template>

<script>
export default {
  name: 'GuestsStepper',
  props: {
    currentStep: {
      type: Number,
      default: 0,
    },
    guests: {
      type: Array,
      default: () => [],
    },
    guestCompletions: {
      type: Object,
      default: () => {},
    },
  }
}
</script>

<style lang='sass'>
  $completed-step-color: #75ae75;
  $not-completed-step-color: #969c9c;
  $not-completed-step-bg-color: #dad8d6;
  $active-step-color: #0d9c0d;

  .checkin .v-stepper.v-stepper--alt-labels.guests-stepper {
    border-radius: 0;

    .v-stepper__header {
      align-items: center;
      justify-content: center;
    }

    .v-stepper__step {
      padding: 5px 15px 5px;
      flex-basis: auto !important;

      &.v-stepper__step--complete:not(.v-stepper__step--active) {
        .v-stepper__step__step,
        .v-stepper__step__step.primary {
          background: transparent !important;
          .v-icon {
            color: $completed-step-color !important;
          }
        }
      }

      &:not(.v-stepper__step--active):not(.v-stepper__step--complete) {
        .v-stepper__step__step,
        .v-stepper__step__step.primary {
          background: $not-completed-step-bg-color !important;
          color: transparent;
          v-icon {
            display: none;
          }
        }
      }

      &.v-stepper__step--active {
        .v-stepper__step__step,
        .v-stepper__step__step.primary {
          color: transparent;
          background: $active-step-color !important;
        }
        &.v-stepper__step--complete {
          .v-stepper__step__step,
          .v-stepper__step__step.primary {
            background: transparentize($active-step-color, .8) !important;
          }
          .v-icon {
            color: $active-step-color !important;
          }
        }
      }
    }

    .v-stepper__step__step {
      height: 10px;
      min-width: 10px;
      max-width: 10px;
      margin-bottom: 0;
    }
  }
</style>
